<template>
  <ul class="w-full h-15 bg-category-menu-bg hidden lg:flex items-center justify-evenly text-base font-bold">
    <li>
      <Link
        :href="translatePath(ROUTES.CODE.NEWS)"
        class="text-category-menu-text hover:text-category-menu-text-hover focus:text-category-menu-text-hover hover:underline"
        active-class="underline"
      >
        {{ $t('text-all-news') }}
      </Link>
    </li>
    <li
      v-for="category in categories.news"
      :key="category.id"
    >
      <Link
        :href="translatePath(ROUTES.CODE.NEWS_ABOUT, slugify(category?.id, category?.name))"
        class="text-category-menu-text hover:text-category-menu-text-hover focus:text-category-menu-text-hover hover:underline"
        active-class="underline"
      >
        {{ category.name }}
      </Link>
    </li>
  </ul>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { useCategoryStore } from '@stores/category';
import Link from "@components/ui/link/link";

const categories = useCategoryStore();

</script>
